<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <div class="fof">
          <h1>Error 404</h1>
        </div>
        <router-link to="/">Regresar a Pagina Principal</router-link>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>
<style scoped>
.fof h1 {
  animation: type .5s alternate infinite;
  display: inline-block;
  font-size: 90px;
  padding-right: 12px;
}

@keyframes type {
  from { box-shadow: inset -3px 0 0 #888; }
  to { box-shadow: inset -3px 0 0 transparent; }
}
</style>
